
import { BleClient } from '@capacitor-community/bluetooth-le';

export default {
  supportsWebLEScan () {
    return typeof navigator !== 'undefined' &&
      !!navigator.bluetooth &&
      typeof navigator.bluetooth.requestLEScan === 'function'
  },

  async init () {
    try {
      console.log('BleClient init');
      return await BleClient.initialize();
    } catch (error) {
      console.error(error);
    }
  },

  async isEnabled () {
    try {
      console.log('BleClient isEnabled');
      return await BleClient.isEnabled()
    } catch (error) {
      console.error(error);
    }
  },

  async onEnabled (callback) {
    try {
      console.log('BleClient onEnabled');
      await BleClient.startEnabledNotifications(callback);
    } catch (error) {
      console.error(error);
    }
  },
      
  async scan (toggle, resolve, reject=null, stop=null, timeout=10000) {
    if (toggle) {
      try {
        // Web Bluetooth LE scan API is not available in all browsers.
        if (!this.supportsWebLEScan()) {
          const error = new Error('Bluetooth LE scan is not supported in this browser.')
          if (!!reject) reject(error)
          if (!!stop) stop()
          return
        }

        console.log('BleClient requestLEScan...');
        await BleClient.requestLEScan(
          {services: []},
          resolve
        );
  
        setTimeout(async () => {
          await BleClient.stopLEScan();
          if (!!stop) stop();
          console.log('BleClient stopped scanning.');
        }, timeout);
      } catch (error) {
        console.log('BleClient error:', error);
        if (!!reject) reject(error);
        if (!!stop) stop();
        console.warn(error);
      }
    }else{
      try {
        await BleClient.stopLEScan();
        console.log('BleClient stopped scanning.');
      } catch (error) {
        console.error(error);
      }
    }
  },
}